export enum MLTagType {
  TAG = 1,
  COLOR = 2,
}

export enum MLTagCreation {
  CORIGHT = 1,
  CUSTOM = 2,
}

export type MLTag = {
  id: string;
  type: MLTagType;
  creation: MLTagCreation;
  label: string;
  value: string;
  categoryTag: string | null;
  categoryTagId: string | null;
  companyId: string | null;
  isCategory: boolean;
};
